import TileMapTile from '../models/tileMapTile.js';

export default class TileMapTileBinarySerialiser {


    /**
     * Serialises the tile map tile to a planar byte array.
     * @param {TileMapTile} tileMapTile - Tile map tile to serialise.
     * @returns {number}
     */
     static serialise(tileMapTile) {
        throw new Error('This method is not implemented.');
    }


}